/* global axios */
import ApiClient from './ApiClient';

class WhatsappSessions extends ApiClient {
  constructor() {
    super('whatsapp_sessions', { accountScoped: true });
  }

  show(inboxId, { withQr = false } = {}) {
    return axios.get(`${this.url}/${inboxId}`, {
      params: { with_qr: withQr ? '1' : '0' },
    });
  }

  restart(inboxId) {
    return axios.post(`${this.url}/${inboxId}/restart`);
  }
}

export default new WhatsappSessions();
